import { useTranslation } from 'react-i18next';
import { Sun, Moon, Languages, Check } from 'lucide-react';
import {
  IconButton,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@vnetwork/ui/primitives';
import { useTheme } from '@vnetwork/ui/provider';
import { setLanguage } from '@/lib/i18n';
import { UserMenu } from './UserMenu';

/** Light/dark theme toggle — @vnetwork/ui theme context, same as @partner. */
function ThemeToggle() {
  const [theme, setTheme] = useTheme();
  return (
    <IconButton
      variant="ghost"
      aria-label="Toggle theme"
      onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
    >
      {theme === 'light' ? <Moon size={18} /> : <Sun size={18} />}
    </IconButton>
  );
}

const LANGS: { code: 'en' | 'vi'; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'vi', label: 'Tiếng Việt' },
];

/** Standalone language switcher (moved out of the account menu). */
function LanguageSwitcher() {
  const { i18n } = useTranslation();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <IconButton variant="ghost" aria-label="Change language">
          <Languages size={18} />
        </IconButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.code} onSelect={() => setLanguage(l.code)}>
            <span aria-hidden style={{ width: 'var(--vn-space-4)', display: 'inline-flex' }}>
              {i18n.language === l.code ? <Check size={14} /> : null}
            </span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

/** Right-aligned topbar cluster: language · theme · account. */
export function TopbarActions() {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--vn-space-1)' }}>
      <LanguageSwitcher />
      <ThemeToggle />
      <UserMenu />
    </div>
  );
}
